// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2PM4B","sendOtp":"AuthorizeToLogin_sendOtp__3EBTu"};